const $ = jQuery;

$(document).ready(function ($) {
    const menu = $('.header-mobileMenu');
    const submenu = $('#languageMobile .language-submenu');
    const menuOpenBtn = $('#menuOpenBtn');
    const menuCloseBtn = $('#menuCloseBtn');
    const mobileMenuItem = $(".header-mobile-content li a");
    const languageMobileBtn = $('#languageMobile > .language');
    const menuCloseLangBtn = $("#menuCloseLangBtn");
    const preloader = $('.center');
    const overlay = $('#overlay');
    preloader.fadeOut();

    const $section = $('.learning');
    const $items = $('.learning-left-item_v3');
    const animationSequence = ['left', 'bottom', 'bottom'];
    const animationDuration = 400;
    const animationDelay = 200;
    let animationTriggered = false;

    const $header = $('.header');
    const fixedClass = 'onscroll';


    $(".currency-dropdown").on("click", function (e) {
        if (!$(e.target).hasClass("currency-option")) {
            $(this).toggleClass("open");
        }
    });

    //Header and Menus

    function menuItemToggle() {
        const item = $('.header-menu > .menu-item-has-children');
        item.on('click', function (e) {
            if (e.target !== this)
                return;
            $(this).toggleClass('active')
            const subMenu = $(this).find('.sub-menu');
            subMenu.eq(0).stop().toggleClass('opened')
        })
    }

    mobileMenuItem.click(function () {
        menu.removeClass('opened');
        overlay.removeClass('opened');
    })

    menuCloseBtn.click(function () {
        menu.removeClass('opened');
        overlay.removeClass('opened');
    })

    menuOpenBtn.click(function () {
        menu.addClass('opened');
        overlay.addClass('opened');
    })

    languageMobileBtn.click(function () {
        submenu.addClass('opened');
        menuCloseBtn.addClass('close');
        menuCloseLangBtn.addClass('opened');
    });

    menuCloseLangBtn.click(function () {
        submenu.removeClass('opened');
        menuCloseBtn.removeClass('close');
        menuCloseLangBtn.removeClass('opened');
    });

    overlay.click(function () {
        menu.removeClass('opened');
        overlay.removeClass('opened');
    })

    //Currency menu

    $(".currency-option").on("click", function (e) {
        e.stopPropagation();
        const selectedCurrency = $(this).data("currency");
        const url = new URL(window.location.href);

        url.searchParams.set("alg_currency", selectedCurrency);
        url.hash = "#packages";
        window.location.href = url.toString();
    });

    // tabs (PathV3)

    $('.tab-link').click(function () {
        const tabId = $(this).attr('data-tab');

        $('.tab-link').removeClass('current');
        $('.tab-content').removeClass('current');

        $(this).addClass('current');
        $('#' + tabId).addClass('current');
    });

    // header fixed

    $(window).on('scroll', function () {
        if ($(window).scrollTop() > 50) {
            $header.addClass(fixedClass);
        } else {
            $header.removeClass(fixedClass);
        }
    });

    //Accordeons

    $('.faq-answer').hide();
    $('.faq .faq-section:first-child .faq-item:nth-child(2) .faq-question').siblings(".faq-answer").slideToggle();
    $('.faq .faq-section:first-child .faq-item:nth-child(2) .faq-question').toggleClass('active');
    $('.faq-question').on('click', function () {
        $(this).next('.faq-answer').stop().slideToggle();
        $(this).toggleClass('active');
    });

    $('.path-item:first-child .path-point-toggle').siblings(".path-description").slideToggle();
    $('.path-item:first-child .path-point-toggle').toggleClass('active');
    $('.path-point-toggle').click(function () {
        $(this).siblings(".path-description").stop().slideToggle();
        $(this).toggleClass('active');
    });

    //Swiper slider

    const swiper = new Swiper(".swiper", {
        slidesPerView: 1,
        spaceBetween: 0,
        pagination: {
            type: 'bullets',
            el: ".swiper-pagination",
            clickable: true,
            enabled: false,
        },
        breakpoints: {
            1091: {
                slidesPerView: 2.2,
                spaceBetween: 24,
                pagination: {
                    enabled: false,
                },
            },

            640: {
                slidesPerView: 1.2,
                spaceBetween: 24,
                pagination: {
                    type: 'bullets',
                    el: ".swiper-pagination",
                    clickable: true,
                    enabled: false,
                },
            },

            1: {
                slidesPerView: 1,
                spaceBetween: 8,
                pagination: {
                    type: 'bullets',
                    el: ".swiper-pagination",
                    clickable: true,
                    enabled: true,
                },
            }
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
    });

    // animation for title (StudyV2 section)

    $(window).on('scroll', function () {
        const $studyLeft = $('.study-left_v2');

        if ($studyLeft.length) {
            const headerHeight = $('header').outerHeight();
            const scrollTop = $(this).scrollTop();
            const elementTop = $studyLeft.offset().top - headerHeight;
            const elementBottom = $studyLeft.offset().top + $studyLeft.outerHeight() - headerHeight;

            if (scrollTop >= elementTop && scrollTop <= elementBottom) {
                $studyLeft.addClass('padding-top');
            } else {
                $studyLeft.removeClass('padding-top');
            }
        }
    });

    //TYPED animation

    if ($('.banner-title').length) {
        const typed = new Typed('.banner-title', {
            strings: [typed_text.main_title],
            typeSpeed: 50,
            startDelay: 0,
            backSpeed: 0,
            backDelay: 0,
            loop: false,
            showCursor: false,
        });
    }

    //Paralax animation

    const sceneBanner = document.getElementById('sceneBanner') || document.getElementById('sceneBanner2') || document.getElementById('sceneBanner3');
    const sceneBanneritem1 = document.getElementById('sceneBanneritem1');
    const sceneBanneritem2 = document.getElementById('sceneBanneritem2');
    const sceneBanneritem3 = document.getElementById('sceneBanneritem3');
    const sceneLearning = document.getElementById('sceneLearningV1') || document.getElementById('sceneLearningV2');
    const sceneLearningV3 = document.getElementById('sceneLearningV3');

    function paralaxInitialize(scene, layersClass, layersClass2) {
        if (scene) {
            const parallaxInstance = new Parallax(scene, {
                pointerEvents: true,
            });

            const layers = scene.querySelectorAll(layersClass);
            const layers2 = scene.querySelectorAll(layersClass2);
            layers.forEach((layer) => {
                layer.style.top = '';
                layer.style.left = '';
            });

            if (layers2) {
                layers2.forEach((layer) => {
                    layer.style.top = '';
                    layer.style.left = '';
                });
            }
        }

    }

    if (window.matchMedia("(min-width: 767px)").matches) {
        if (sceneBanneritem1) {
            paralaxInitialize(sceneBanneritem1, '.banner-img-item');
        }

        if (sceneBanneritem2) {
            paralaxInitialize(sceneBanneritem2, '.banner-img-item');
        }

        if (sceneBanneritem3) {
            paralaxInitialize(sceneBanneritem3, '.banner-img-item');
        }

        if (sceneBanner) {
            switch (sceneBanner.id) {
                case "sceneBanner":
                    paralaxInitialize(sceneBanner, '.banner-img_v1');
                    break;
                case "sceneBanner2":
                    paralaxInitialize(sceneBanner, '.banner-img_v2');
                    break;
                case "sceneBanner3":
                    paralaxInitialize(sceneBanner, '.banner-img_v3');
                    break;
            }
        }

        if (sceneLearning) {
            switch (sceneLearning.id) {
                case "sceneLearningV1":
                    paralaxInitialize(sceneLearning, '.learning-left-item_v1');
                    break;
                case "sceneLearningV2":
                    paralaxInitialize(sceneLearning, '.learning-left-item_v2', '.learning-left-circle');
                    break;
            }
        }

        function isElementInViewport(el) {
            if (!el) return false;
            const rect = el.getBoundingClientRect();
            return rect.top < window.innerHeight && rect.bottom > 0;
        }

        function animateItems() {
            $items.each(function (index) {
                const $item = $(this);
                const direction = animationSequence[index];
                let animationProps = { opacity: 1 };

                if (direction === 'left') {
                    animationProps.left = $item.css('left');
                    $item.css({ left: '-100%', opacity: 0 });
                } else if (direction === 'bottom') {
                    animationProps.top = $item.css('top');
                    $item.css({ top: '100%', opacity: 0 });
                }

                setTimeout(() => {
                    $item.animate(animationProps, animationDuration, function () {
                        if (index === $items.length - 1) {
                            paralaxInitialize(sceneLearningV3, '.learning-left-item_v3');
                        }
                    });
                }, index * (animationDuration + animationDelay));
            });
        }

        $(window).on('scroll', function () {
            if (!animationTriggered && isElementInViewport($section[0])) {
                animationTriggered = true;
                animateItems();
            }
        });

        $(window).on('scroll', function () {
            if (!animationTriggered && isElementInViewport($section[0])) {
                animationTriggered = true;
                animateItems();
            }
        });
    }

    //scrollReveal animation

    ScrollReveal().reveal('.impact-item_v1:first-child .impact-image', {
        duration: 500,
        distance: '50%',
        origin: 'bottom',
        easing: 'ease-in',
        reset: false,
        viewFactor: 1,
        mobile: false,
    });

    ScrollReveal().reveal('.impact-item_v1:first-child .impact-text', {
        duration: 500,
        distance: '50%',
        delay: '200',
        origin: 'bottom',
        easing: 'ease-in',
        reset: false,
        viewFactor: 1,
        mobile: false,
    });

    ScrollReveal().reveal('.impact-item_v1:nth-child(2) .impact-image', {
        duration: 500,
        distance: '50%',
        origin: 'bottom',
        delay: '600',
        easing: 'ease-in',
        reset: false,
        viewFactor: 1,
        mobile: false,
    });

    ScrollReveal().reveal('.impact-item_v1:nth-child(2) .impact-text', {
        duration: 500,
        distance: '50%',
        origin: 'bottom',
        delay: '400',
        easing: 'ease-in',
        reset: false,
        viewFactor: 1,
        mobile: false,
    });

    ScrollReveal().reveal('.impact-item_v1:nth-child(3) .impact-image', {
        duration: 500,
        distance: '50%',
        origin: 'bottom',
        delay: '800',
        easing: 'ease-in',
        reset: false,
        viewFactor: 1,
        mobile: false,
    });

    ScrollReveal().reveal('.impact-item_v1:nth-child(3) .impact-text', {
        duration: 500,
        distance: '50%',
        origin: 'bottom',
        delay: '1000',
        easing: 'ease-in',
        reset: false,
        viewFactor: 1,
        mobile: false,
    });

    ScrollReveal().reveal('.impact-item_v1:last-child .impact-image', {
        duration: 500,
        distance: '50%',
        origin: 'bottom',
        delay: '1400',
        easing: 'ease-in',
        reset: false,
        viewFactor: 1,
        mobile: false,
    });

    ScrollReveal().reveal('.impact-item_v1:last-child .impact-text', {
        duration: 500,
        distance: '50%',
        origin: 'bottom',
        delay: '1200',
        easing: 'ease-in',
        reset: false,
        viewFactor: 1,
        mobile: false,
    });

    ScrollReveal().reveal('.impact-item_v2:first-child', {
        duration: 500,
        distance: '50%',
        origin: 'bottom',
        easing: 'ease-out',
        reset: false,
        viewFactor: 1,
        mobile: false,
    });

    ScrollReveal().reveal('.impact-item_v2:nth-child(2)', {
        duration: 500,
        distance: '50%',
        origin: 'bottom',
        delay: '200',
        easing: 'ease-out',
        reset: false,
        viewFactor: 1,
        mobile: false,
    });

    ScrollReveal().reveal('.impact-item_v2:nth-child(3)', {
        duration: 500,
        distance: '50%',
        origin: 'bottom',
        delay: '400',
        easing: 'ease-out',
        reset: false,
        viewFactor: 1,
        mobile: false,
    });

    ScrollReveal().reveal('.impact-item_v2:nth-child(4)', {
        duration: 500,
        distance: '50%',
        origin: 'bottom',
        delay: '600',
        easing: 'ease-out',
        reset: false,
        viewFactor: 1,
        mobile: false,
    });

    ScrollReveal().reveal('.impact-item_v3:first-child', {
        duration: 500,
        distance: '50%',
        origin: 'bottom',
        easing: 'ease-out',
        reset: false,
        viewFactor: 1,
        mobile: false,
    });

    ScrollReveal().reveal('.impact-item_v3:nth-child(2)', {
        duration: 500,
        distance: '50%',
        origin: 'bottom',
        delay: '200',
        easing: 'ease-out',
        reset: false,
        viewFactor: 1,
        mobile: false,
    });

    ScrollReveal().reveal('.impact-item_v3:nth-child(3)', {
        duration: 500,
        distance: '50%',
        origin: 'bottom',
        delay: '400',
        easing: 'ease-out',
        reset: false,
        viewFactor: 1,
        mobile: false,
    });

    ScrollReveal().reveal('.impact-item_v3:nth-child(4)', {
        duration: 500,
        distance: '50%',
        origin: 'bottom',
        delay: '600',
        easing: 'ease-out',
        reset: false,
        viewFactor: 1,
        mobile: false,
    });

    ScrollReveal().reveal('.study-item:first-child', {
        duration: 500,
        distance: '50%',
        origin: 'bottom',
        easing: 'ease-out',
        reset: false,
        viewFactor: 1,
        mobile: false,
    });

    ScrollReveal().reveal('.study-item:nth-child(2)', {
        duration: 500,
        distance: '50%',
        origin: 'bottom',
        delay: '200',
        easing: 'ease-out',
        reset: false,
        viewFactor: 1,
        mobile: false,
    });

    ScrollReveal().reveal('.study-item:nth-child(3)', {
        duration: 500,
        distance: '50%',
        origin: 'bottom',
        delay: '400',
        easing: 'ease-out',
        reset: false,
        viewFactor: 1,
        mobile: false,
    });

    ScrollReveal().reveal('.study-item:nth-child(4)', {
        duration: 500,
        distance: '50%',
        origin: 'bottom',
        delay: '600',
        easing: 'ease-out',
        reset: false,
        viewFactor: 1,
        mobile: false,
    });

    ScrollReveal().reveal('.study-item:nth-child(5)', {
        duration: 500,
        distance: '50%',
        origin: 'bottom',
        delay: '800',
        easing: 'ease-out',
        reset: false,
        viewFactor: 1,
        mobile: false,
    });

    ScrollReveal().reveal('.path-content_v2', {
        duration: 500,
        distance: '50px',
        origin: 'bottom',
        easing: 'ease-out',
        reset: false,
        viewFactor: .4,
        mobile: false,
    });

    ScrollReveal().reveal('.reviews-item:first-child', {
        duration: 500,
        distance: '50%',
        origin: 'bottom',
        easing: 'ease-out',
        reset: false,
        viewFactor: 1,
        mobile: false,
    });

    ScrollReveal().reveal('.reviews-item:nth-child(2)', {
        duration: 500,
        distance: '50%',
        delay: '500',
        origin: 'bottom',
        easing: 'ease-out',
        reset: false,
        viewFactor: 1,
        mobile: false,
    });

    ScrollReveal().reveal('.reviews-item:nth-child(3)', {
        duration: 500,
        distance: '50%',
        delay: '1000',
        origin: 'bottom',
        easing: 'ease-out',
        reset: false,
        viewFactor: 1,
        mobile: false,
    });

    ScrollReveal().reveal('.reviews-chat', {
        duration: 500,
        distance: '50%',
        delay: '1000',
        origin: 'right',
        easing: 'ease-out',
        reset: false,
        viewFactor: 1,
        mobile: false,
    });

    ScrollReveal().reveal('.path-description-item_first:nth-child(2)', {
        duration: 500,
        distance: '50%',
        origin: 'right',
        easing: 'ease-out',
        reset: false,
        viewFactor: 1,
        mobile: false,
    });

    ScrollReveal().reveal('.path-description-item_first:nth-child(3)', {
        duration: 500,
        distance: '50%',
        delay: '300',
        origin: 'right',
        easing: 'ease-out',
        reset: false,
        viewFactor: 1,
        mobile: false,
    });

    ScrollReveal().reveal('.path-description-item_first:nth-child(4)', {
        duration: 500,
        distance: '50%',
        delay: '600',
        origin: 'right',
        easing: 'ease-out',
        reset: false,
        viewFactor: 1,
        mobile: false,
    });

    ScrollReveal().reveal('.path-button_first', {
        duration: 500,
        distance: '50%',
        delay: '900',
        origin: 'bottom',
        easing: 'ease-out',
        reset: false,
        viewFactor: 1,
        mobile: false,
    });

    menuItemToggle();
});

const btn = $('#top');

$(window).scroll(function () {
    if ($(window).scrollTop() > 300) {
        btn.addClass('show');
    } else {
        btn.removeClass('show');
    }
});

btn.on('click', function (e) {
    e.preventDefault();
    $('html, body').animate({ scrollTop: 0 }, '300');
});

$(document).on('click', 'a[href^="#"]', function (event) {
    const targetId = $(this).attr('href');
    if (targetId.length <= 1) {
        return;
    }
    const $targetElement = $(targetId);
    if ($targetElement.length) {
        event.preventDefault();

        $('html, body').animate({
            scrollTop: $targetElement.offset().top - 50
        }, 500);
    }
});
